import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';

interface Report {
  lastGeneratedDate: Date,
  customerName: string,
  customerIC: string,
  customerId: number
}

@Component({
    selector: 'app-form-j-report',
    templateUrl: './form-j-report.component.html',
    styleUrls: ['./form-j-report.component.scss'],
    standalone: false
})


export class FormJReportComponent implements OnInit {
  protected enums = inject(Enums);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() selectedCompany: number;
  @Input() reportName: string;

  reportList: Report[] = [];
  wholeReportList: Report[] = [];

  isCollapsed = false;

  routeSubscription: any;

  isBranchManager: boolean;

  ngOnInit(): void {

    this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
      this.selectedCompany = + params.get('companyId');

      this.getCompanyFormJLatestDate();
    });
  }

  goToCustomer(customerID: number) {
    this.router.navigate(['/manageCustomer', customerID]);
  }

  getCompanyFormJLatestDate() {
    this.reportList.splice(0, this.reportList.length);
    const xhttp = this.restapi.getRequest(this.constructApi.getCompanyFormJLatestDate(this.selectedCompany));

    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {

        const jsonArray = JSON.parse((xhttp.responseText));
        jsonArray.forEach(json => {
          const report = {
            customerId: json.id, customerName: json.name, customerIC: json.icNumber, lastGeneratedDate: json.lastFormJDate
          };
          this.reportList.push(report);
        }
        );
      }
    };
  }


}
